<template>
  <FormInput :label-for="labelFor" :label-text="labelText"
             :show-error="showError" :error-text="errorText"
             :required="required"
  >
    <select @change="updateInput"
            :id="labelFor" v-model="value"
            :class="{ 'error': hasError }">
      <option value="">{{ $t('optionSelect') }}...</option>
      <template v-for="option in options" :key="option">
        <option v-if="option.id == null" value="disabled" disabled>
          ----------------------------------------------
        </option>
        <option v-else :value="option.id" :selected="option.selected">{{ option.name }}</option>
      </template>
      <slot name="extraOptions"></slot>
    </select>
  </FormInput>
</template>
<script>
import FormInput from "./FormInput.vue";

export default {
  components: {FormInput},
  props: {
    labelFor: {
      type: String,
      required: true,
    },
    labelText: {
      type: String,
      required: true,
    },
    selectValue: {
      required: true,
    },
    options: {
      required: false,
      default: [],
    },
    showError: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['change'],
  data() {
    return {
      value: this.selectValue,
    }
  },
  computed: {
    hasError() {
      return this.showError && this.errorText.length > 0;
    }
  },
  methods: {
    updateInput() {
      this.$emit('change', {value: this.value});
    }
  }
}
</script>
<style scoped>
.form-input select {
  opacity: 1;
}

select.error {
  border: 1px solid red !important;
}

select.error {
  outline-color: red;
}

</style>